<template>
    <div class="col-12 mx-auto">
        <div class="card">
            <dashboard-ctrl :componentName="componentName"
                            :showHideButton="showHideButton"
                            :showPinButton="showPinButton"
                            :showResizeIcon="showResizeIcon"
                            :size="size"
                            :headerTitle="titleKey"
                            :componentClass="'card-header bg-primary text-white'"
                            :showHeadful="showHeadful"
                            @hide="hide"
                            @resize="resize"
                            @pinned="pinned"
                            @unpinned="unpinned">
            </dashboard-ctrl>

            <div class="card-header" v-if="showSettingsBtn">
                <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings ref="userSettings"
                                    :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    :useLabelAsTitle="true"
                                    :showUserSettings="true"
                                    :gridOptions="userSettings"
                                    v-if="showUserSettingsForm"
                                    @saveGridSettings="saveGridSettings"
                                    @loadGridSettings="loadGridSettings"
                                    @deleteGridSettings="deleteGridSettings"
                                    @userSettingsChanged="userSettingsChanged">
                </grid-user-settings>
            </div>

            <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12">

                </div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button type="button" class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button type="button" class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body" id="completedFormsGrid">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="gridOptions.pageable.size"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <kendo-grid ref="completedFormsGrid"
                            :data-source-ref="'datasource1'"
                            :pageable="gridOptions.pageable"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="toolbar"
                            :excel="gridOptions.excel"
                            :pdf="gridOptions.pdf"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :filterable="false"
                                       :title="$t('registers.forms.gridHeaders.id')"
                                       :width="100"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'registerEntityId'"
                                       :filterable="true"
                                       :title="$t('registers.forms.gridHeaders.registerEntityId')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'formName'"
                                       :title="$t('registers.forms.gridHeaders.formName')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'formNameEn'"
                                       :title="$t('registers.forms.gridHeaders.formName')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'formType'"
                                       :title="$t('registers.forms.gridHeaders.formType')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'formTypeEn'"
                                       :title="$t('registers.forms.gridHeaders.formTypeEn')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'"
                                       :title="$t('registers.forms.gridHeaders.eventName')"
                                       :width="300"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'creatorFullName'"
                                       :title="$t('registers.forms.gridHeaders.creator')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'creatorPosition'"
                                       :title="$t('registers.forms.gridHeaders.position')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'creatorPositionEn'"
                                       :title="$t('registers.forms.gridHeaders.position')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('registers.forms.gridHeaders.eventStartDate')"
                                       :width="200"
                                       :format="customDatetimeFormat"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('registers.forms.gridHeaders.eventEndDate')"
                                       :width="200"
                                       :format="customDatetimeFormat"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationStatus'"
                                       :title="$t('registers.forms.gridHeaders.participationStatus')"
                                       :width="140"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationStatusEn'"
                                       :title="$t('registers.forms.gridHeaders.participationStatus')"
                                       :width="140"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAtUtc'"
                                       :title="$t('registers.forms.gridHeaders.createdAtUtc')"
                                       :width="200"
                                       :format="customDatetimeFormat"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAtUtc'"
                                       :title="$t('registers.forms.gridHeaders.updatedAtUtc')"
                                       :width="200"
                                       :format="customDatetimeFormat"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'status'"
                                       :title="$t('registers.forms.gridHeaders.status')"
                                       :width="140"
                                       :lockable="true"
                                       :locked="false"
                                       :template="statusCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showBtns && hasCompletingRights"
                                       field="btnsColumn"
                                       :title="$t('registers.forms.gridHeaders.management')"
                                       :sortable="false"
                                       :filterable="false"
                                       :template="btnsTemplate"
                                       :width="140"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>

                    <kendo-contextmenu @select="selectContextMenu" :target="'#completedFormsGrid'" :filter="'td'">
                        <!--<li v-if="hasReadRights" :id="'detailsAll'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.details.btnText') }}</li>-->
                        <li v-if="hasReadRights" :id="'detailsActive'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.details.btnText') }}</li>
                        <!--<li v-if="hasReadRights" :id="'detailsShowInDescription'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.detailsShowInDescription.btnText') }}</li>-->
                    </kendo-contextmenu>
                </kendo-grid>
            </div>
        </div>
        <EventEntryDetailsModal v-model="eventEntryDetailsModel" :show="showEventEntryDetails" @onClose="onEventEntryDetailsClose"></EventEntryDetailsModal>
        <FormEntryDetailsModal v-model="formEntryDetailsModel" :show="showFormEntryDetails" @onClose="onFormEntryDetailsClose"></FormEntryDetailsModal>

    </div>

</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from "../../components/grid/UserSettings";
    import ControlBtnsTemplate from "../../components/dashboard/ControlBtnsTemplate";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import { RegisterFieldValueQueryFilter, KendoGridPageSize } from '../../models/enums';
    import EventEntryDetailsModal from '../dynamic/register/details.modal';
    import FormEntryDetailsModal from './entryView/details.modal';
    import personalizationService from '../../services/personalization.service';
    import { mapGetters } from 'vuex';

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        name: 'completed-forms-grid',
        components: {
            'dashboard-ctrl': ControlBtnsTemplate,
            'grid-user-settings': GridUserSettings,
            EventEntryDetailsModal,
            FormEntryDetailsModal
        },
        created: function () {
            window.JSZip = JSZip // ���������� � �� �� ������ �������� � excel
        },
        props: {
            // ����������, ����� ������� �� ���������� � �������� �� ������� �����������
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: false,
                type: Boolean
            },
            showResizeIcon: {
                default: true,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            listAll: {
                type: Boolean,
                default: false
            },
            returnUrl: {
                type: String,
                default: ''
            },
            dateFormat: {
                default: 'dd-MM-yyyy HH:mm:ss',
                type: String
            },
            userId: {
                default: null,
                type: String
            },
            eventId: {
                type: String,
                default: ''
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                componentName: this.listAll ? 'CompletedFormsListGrid' : 'MyFormsListGrid',
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                titleKey: this.listAll || !this.isCurrent ? 'registers.forms.completed' : 'registers.forms.my',
                searchQuery: '',
                eventEntryDetailsModel: null,
                showEventEntryDetails: false,
                formEntryDetailsModel: null,
                showFormEntryDetails: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.id' },
                    registerEntityId: { name: 'registerEntityId', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.registerEntityId' },
                    createdAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.createdAtUtc' },
                    updatedAtUtc: { name: 'updatedAtUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.updatedAtUtc' },
                    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.deleted' },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.deactivated' },
                    updated: { name: 'updated', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.updated' },
                    creatorFullName: { name: 'creatorFullName', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.name' },
                    creatorPosition: { name: 'creatorPosition', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.position' },
                    creatorPositionEn: { name: 'creatorPositionEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.position' },
                    formToRegisterEntityId: { name: 'formToRegisterEntityId', type: 'number', editable: false, nullable: true, visible: false, titleKey: 'registers.forms.gridHeaders.id' },
                    registerFieldValueId: { name: 'registerFieldValueId', type: 'number', editable: false, nullable: true, visible: false, titleKey: 'registers.forms.gridHeaders.id' },
                    formName: { name: 'formName', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formName' },
                    formNameEn: { name: 'formNameEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formName' },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.eventName' },
                    eventStartDate: { name: 'eventStartDate', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.eventStartDate' },
                    eventEndDate: { name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.eventEndDate' },
                    eventStatus: { name: 'eventStatus', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.eventStatus' },
                    eventStatusEn: { name: 'eventStatusEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.eventStatus' },
                    formType: { name: 'formType', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formType' },
                    formTypeEn: { name: 'formTypeEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formType' },
                    status: { name: 'status', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.status' },
                    canEdit: { name: 'canEdit', type: 'boolean', editable: false, nullable: false, visible: false, titleKey: 'registers.forms.gridHeaders.canEdit' }
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    excel: {
                        fileName: 'CompletedForms.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'CompletedForms.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                showUserSettingsForm: false,
            }
        },
        methods: {
            onEventEntryDetailsClose() {
                this.showEventEntryDetails = false;
                this.eventEntryDetailsModel = null;
            },
            onFormEntryDetailsClose() {
                this.showFormEntryDetails = false;
                this.formEntryDetailsModel = null;
            },
            dataBound(e) {
                if (!this.customSettingsLoaded) {
                    this.customSettingsLoaded = true;
                    this.loadGridSettings();
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    let newOptions = { Request: options, userId: this.userId ? this.userId : '' };

                    return kendo.stringify(newOptions);
                }
            },
            getGridOptions() {
                const grid = this.$refs.completedFormsGrid.kendoWidget();
                if (grid) {
                    return grid.getOptions();
                }
            },
            saveGridSettings() {
                const gridSettings = this.getGridOptions();
                const grid = this.$refs.completedFormsGrid.kendoWidget();

                if (gridSettings && grid) {
                    this.$refs.userSettings.setGridSettings(gridSettings);

                    personalizationService
                        .saveGridSettings(this.componentName, gridSettings)
                        .then(response => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration
                            })
                        });
                }
            },
            loadGridSettings() {
                personalizationService
                    .loadGridSettings(this.componentName)
                    .then(response => {
                        try {
                            var options = personalizationService
                                .mergePersonGridSettings(this.getGridOptions(), response.data.settings);

                            let grid = this.$refs.completedFormsGrid.kendoWidget();
                            if (options && grid) {
                                grid.setOptions(options);

                                if (options.pageable.size != grid.dataSource.options.pageSize) {
                                    grid.dataSource.pageSize(options.pageable.size);
                                    grid.refresh();
                                }

                                const userSettingsEditor = this.$refs.userSettings;
                                if (userSettingsEditor) {
                                    userSettingsEditor.setGridSettings(grid.getOptions());
                                }
                            }

                            this.customSettingsLoaded = true;
                        } catch (e) {
                            this.customSettingsLoaded = true;
                        }

                    })
                    .catch(error => {
                        this.customSettingsLoaded = true;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            deleteGridSettings() {
                personalizationService
                    .delteGridSettings(this.componentName)
                    .then(response => {
                        this.$router.go();
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.completedFormsGrid.kendoWidget();

                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            if (userSettings.pageable.size == KendoGridPageSize.All) {
                                grid.dataSource.pageSize(grid.dataSource.total());
                            }
                            else {
                                grid.dataSource.pageSize(userSettings.pageable.size);
                            }
                            grid.refresh();
                        }
                    } catch (e) {
                        return;
                    }
                }
            },
            hasCompletingRights() {
                return true;
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            resize(componentName, size) {
                this.$emit('resize', componentName, size, this.$refs.completedFormsGrid.kendoWidget())
            },
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.status.indexOf('Active') >= 0 ? 'badge-success' : (dataItem.status.indexOf('Passed') >= 0 ? 'badge-warning' : 'badge-info')) + '">' + kendo.htmlEncode(dataItem.status) + '</span>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        returnUrl: this.returnUrl ? this.returnUrl : '/forms/my',
                        parentComponent: this.$refs.completedFormsGrid,
                        btns: e.id && e.id > 0
                            ? (
                                e.canEdit && this.isCurrent
                                    ? [
                                        {
                                            name: "edit",
                                            text: this.$t('buttons.edit.btnText'),
                                            tooltip: this.$t('buttons.edit.btnText'),
                                            class: 'btn btn-primary',
                                            icon: "fas fa-edit",
                                            show: this.hasCreateRights,
                                            clickHandler: this.editBtnClick
                                        },
                                        {
                                            name: "eventDetails",
                                            text: this.$t('buttons.eventDetails.btnText'),
                                            tooltip: this.$t('buttons.details.btnText'),
                                            class: 'btn btn-primary',
                                            icon: "fas fa-eye",
                                            show: e.registerEntityId && this.claims.eventDetails.read,
                                            clickHandler: this.eventEntryDetailsBtnClick
                                        }
                                        //{
                                        //    name: "editInNewTab",
                                        //    text: this.$t('buttons.editInNewTab.btnText'),
                                        //    tooltip: this.$t('buttons.editInNewTab.btnText'),
                                        //    class: 'btn btn-primary',
                                        //    icon: "fas fa-pencil-alt",
                                        //    show: this.hasCreateRights,
                                        //    clickHandler: this.editInTewTabBtnClick
                                        //}
                                    ]
                                    : [
                                        {
                                            name: "details",
                                            text: this.$t('buttons.details.btnText'),
                                            tooltip: this.$t('buttons.details.btnText'),
                                            class: 'btn btn-primary',
                                            icon: "fas fa-eye",
                                            show: true,
                                            clickHandler: this.detailsBtnClick
                                        },
                                        {
                                            name: "eventDetails",
                                            text: this.$t('buttons.eventDetails.btnText'),
                                            tooltip: this.$t('buttons.details.btnText'),
                                            class: 'btn btn-primary',
                                            icon: "fas fa-eye",
                                            show: e.registerEntityId && this.claims.eventDetails.read,
                                            clickHandler: this.eventEntryDetailsBtnClick
                                        }
                                        //{
                                        //    name: "detailsInNewTab",
                                        //    text: this.$t('buttons.detailsInNewTab.btnText'),
                                        //    tooltip: this.$t('buttons.detailsInNewTab.btnText'),
                                        //    class: 'btn btn-primary',
                                        //    icon: "fas fa-eye",
                                        //    show: true,
                                        //    clickHandler: this.detailsInTewTabBtnClick
                                        //}
                                    ]
                            )
                            : [],
                    }
                };
            },
            editBtnClick(args) {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push(`/forms/entryEdit?id=${args.formToRegisterEntityId}&entryId=${args.id}&name=${args.eventName}&returnUrl=${args.returnUrl}`);
            },
            editInTewTabBtnClick(args) {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({
                    name: 'editFormEntry', params: {
                        id: args.formToRegisterEntityId,
                        entryId: args.id,
                        name: args.eventName,
                        returnUrl: args.returnUrl
                    }
                })
                window.open(routeData.href, '_blank')
            },
            detailsBtnClick(args) {
                let routeData = this.$router.resolve({
                    name: 'detailsFormEntry',
                    query: { id: args.formToRegisterEntityId, entryId: args.id, name: args.eventName, returnUrl: args.returnUrl }
                });
                window.open(routeData.href, '_blank');
            },
            eventEntryDetailsBtnClick: function (args) {
                if (args.registerEntityId) {
                    this.showEventEntryDetailsModal(args, RegisterFieldValueQueryFilter.All);
                } else {
                    this.$vs.notify({
                        title: this.$t('notifications.noEvent'),
                        text: this.$t('notifications.thereIsNoConnectedEvent'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            formEntryDetailsBtnClick: function (args) {
                if (args.id) {
                    this.showFormEntryDetailsModal(args, RegisterFieldValueQueryFilter.Active);
                } else {
                    this.$vs.notify({
                        title: this.$t('notifications.noForm'),
                        text: this.$t('notifications.thereIsNoConnectedForm'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            showEventEntryDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.eventEntryDetailsModel = model;
                            this.showEventEntryDetails = true;
                        }
                    })
                    .catch(error => {
                        this.eventEntryDetailsModel = null;
                        this.showEventEntryDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            showFormEntryDetailsModal(args, filter) {
                this.$api.dynamicForm
                    .getEntryDetails(args.id, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.formEntryDetailsModel = model;
                            this.formEntryDetailsModel.formNameEn = args.formNameEn;
                            this.formEntryDetailsModel.eventName = args.eventName;
                            this.formEntryDetailsModel.creatorFullName = args.creatorFullName;
                            this.formEntryDetailsModel.createdAtUtc = args.createdAtUtc;
                            this.formEntryDetailsModel.updatedAtUtc = args.updatedAtUtc;

                            this.showFormEntryDetails = true;
                        }
                    })
                    .catch(error => {
                        this.formEntryDetailsModel = null;
                        this.showFormEntryDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            detailsInTewTabBtnClick(args) {
                let routeData = this.$router.resolve({
                    name: 'detailsFormEntry', params: {
                        id: args.formToRegisterEntityId,
                        entryId: args.id,
                        name: args.eventName,
                        returnUrl: args.returnUrl
                    }
                })
                window.open(routeData.href, '_blank')
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.completedFormsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    });

                    return;
                }

                let grid = this.$refs.completedFormsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            selectContextMenu(e) {
                var btnId = e.item.id;
                var index = e.target.parentElement.rowIndex;
                var row = this.$refs.completedFormsGrid.kendoWidget().dataSource.data()[index]
                var id = row.id;
                const args = { id: id, eventName: row.eventName, formNameEn: row.formNameEn, creatorFullName: row.creatorFullName, createdAtUtc: row.createdAtUtc, updatedAtUtc: row.updatedAtUtc };

                if (btnId === 'detailsAll') {
                    this.detailsAllBtnClick(args)

                } else if (btnId === 'detailsActive') {
                    this.detailsActiveBtnClick(args)

                } else if (btnId === 'detailsShowInDescription') {
                    this.detailsShowInDescriptionBtnClick(args)
                }
            },
            detailsAllBtnClick(args) {
                this.showFormEntryDetailsModal(args, RegisterFieldValueQueryFilter.All);
            },
            detailsShowInDescriptionBtnClick(args) {
                this.showFormEntryDetailsModal(args, RegisterFieldValueQueryFilter.ShowInDescription);
            },
            detailsActiveBtnClick(args) {
                this.showFormEntryDetailsModal(args, RegisterFieldValueQueryFilter.Active);
            },
        },
        mounted() {},
        computed: {
            ...mapGetters(['dateTimeFormat', 'isEnVersion', 'claims']),
            customDatetimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.completedFormsGrid.kendoWidget();
                return grid.getOptions();
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            transportSettings() {
                let transportSetings = {
                    read: {
                        url: this.$store.getters.baseUrl + (this.listAll ? '/api/dynamicForms/listAll' : '/api/dynamicForms/listMy'),
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                };

                return transportSetings;
            },
            hasCreateRights() {
                return this.claims.formSurveyEntity.create;
            },
            hasReadRights() {
                return this.claims.formSurveyEntity.read;
            },
            isCurrent() {
                return this.userId && this.userId === this.$store.getters.userId;
            },
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
